import { FC } from 'react';

import { Flex, FlexProps, Tag, theme, Typography } from 'antd';

import { ITag } from 'shared/typings';

interface IOfferTagsProps extends Omit<FlexProps, 'children'> {
	tags: ITag[];
}

export const OfferTags: FC<IOfferTagsProps> = ({ className, tags, ...props }) => {
	const {
		token: { cyan6 },
	} = theme.useToken();

	return (
		<Flex {...props} className={className} gap={4} wrap>
			{tags.map((tag) => (
				<Tag key={tag.slug} color="cyan" style={{ margin: 0 }}>
					<Typography.Text style={{ fontSize: 12, maxWidth: 142, color: cyan6 }} ellipsis={{ tooltip: tag.name }}>
						{tag.name}
					</Typography.Text>
				</Tag>
			))}
		</Flex>
	);
};
